export const ROUTES = {
  /* MANAGEMENT */
  PEOPLE: 'people',
  USERS: 'users',
  ROLES: 'roles',
  OBJECTS_NEW: 'objects-new',
  OBJECTS: 'objects',
  TENANTS: 'tenants',
  RENT_OBJECTS: 'rent-objects',
  ENTERPRISES: 'enterprises',
  PARKING: 'parking',
  PARKING_LOTS: 'parking-lots',
  CONTAINERS: 'containers',
  INTERCOMS: 'intercoms',
  CCTV: 'cctv',
  DOORS: 'doors',
  BARRIERS: 'barriers',
  GUESTS: 'guests',
  VEHICLES: 'vehicles',
  MARKET_COMPANIES: 'market-companies',
  MARKET_OFFERS: 'market-offers',
  COMPANY: 'company',
  NEWS: 'news',
  VOTING: 'voting',
  QUARANTINE: 'quarantine',
  ANALYTICS: 'analytics',
  STATISTICS: 'statistics',
  COUNTERS: 'counters',
  TICKETS_DISPLAY: 'tickets-display',
  TICKETS: 'tickets',
  REPORTS: 'reports',
  ALARMS: 'alarms',
  APPOINTMENT: 'appointment',
  APPEALS: 'appeals',
  CALLS: 'calls',
  CONNECTIONS: 'connections',
  PASSES: 'passes',
  PROFILE: 'profile',
  ENTERPRISE_PROFILE: 'enterprise-profile',
  EVENTS_LOG: 'events-log',
  EQUIPMENT: 'equipment',
  ACCESS_KEYS: 'access-keys',
  ACCESS_GROUPS: 'access-groups',
  DASHBOARD: 'dashboard',
  DASHBOARD_CLIMATE: 'dashboard-climate',
  RESIDENTS_NEW: 'residents-new',
  ENTERPRISE_LIST: 'enterprise-list',
  ENTERPRISE_CONTRACTOR: 'enterprise-contractor',
  ACTIVITY: 'activity',
  ACCOUNTS: 'accounts',
  CONCIERGE: 'concierge',
  JOB_SCHEDULE: 'job-schedule',
  TBO_SCHEDULE: 'tbo-schedule',
  PLANNED_WORK_SCHEDULE: 'planned-work-schedule',
  INSPECTIONS: 'inspections',
  COUNTERS_CHECK: 'counters-check',
  SECURITY: 'security',
  BARRIERS_NEW: 'barriers-new',
  STUFF: 'stuff',
  ACCOUNTS_NEW: 'accounts-new',
  RENT: 'rent',
  POLLS: 'polls',
  MESSAGES: 'messages',
  STORIES: 'stories',
  APARTMENT_ACCEPTANCE: 'apartment-acceptance',
  STATISTICS_COMMUNICATION: 'statistics-communication',
  INDICATORS_PANEL: 'indicators-panel',
  PASS_CONFIG: 'pass-config',
  USERS_GROUPS: 'users-groups',
  ACCESS_LEVEL: 'access-level',
  SCHEDULE: 'schedule',
  GUESTS_TYPES: 'guests-types',
  DEBTORS_LIST: 'debtors-list',
  DEBTORS_NOTIFICATIONS: 'debtors-notifications',
  DEBTORS_RECEIPTS: 'debtors-receipts',
  DEBTORS_SETTINGS: 'debtors-settings',
  DEBTORS_ACCESS: 'debtors-access',
  USER_APP: 'user-app',
  CLIENT_PREMISES: 'client-premises',
  SMS_GATEWAY_SETTINGS: 'sms-gateway-settings',
  WORKS: 'works',
  WORK_FLOWS: 'work-flows',
  TICKETS_TYPES: 'tickets-types',
  EVENT_SERVICE: 'event-service',
  DEVICES_HINTS: 'devices-hints',
  PLANNED_WORKS: 'planned-works',
  QUALIFICATIONS: 'qualifications',
  CHECK_LISTS: 'check-lists',
  EMPLOYEE_ASSIGNMENT: 'employee-assignment',
  TICKETS_FIELDS: 'tickets-fields',
  TICKETS_SCHEMAS: 'tickets-schemas',
  JOURNAL_USER_ACTIONS: 'journal-user-actions',
  JOURNAL_USERS_ACTIONS: 'journal-users-actions',
  CHANNELS: 'channels',
  DOCUMENT_FLOW: 'document-flow',
  /* ENTERPRISES */
  ENTERPRISES_NEWS: 'enterprises-news',
  ENTERPRISES_VEHICLES: 'enterprises-vehicles',
  ENTERPRISES_TICKETS: 'enterprises-tickets',
  ENTERPRISES_EVENTS: 'enterprises-events',
  ENTERPRISES_COMPANY: 'enterprises-company',
  ENTERPRISES_EMPLOYEE: 'enterprises-employee',
  ENTERPRISES_PASSES: 'enterprises-passes',
  ENTERPRISES_CONTACTS: 'enterprises-contacts',
  ENTERPRISES_OBJECTS: 'enterprises-objects',
  ENTERPRISES_PARKING: 'enterprises-parking',
  ENTERPRISES_STUFF: 'enterprises-stuff',
};
